import { render, staticRenderFns } from "./dialogUpdatePosition.vue?vue&type=template&id=31c24624&scoped=true"
import script from "./dialogUpdatePosition.vue?vue&type=script&lang=js"
export * from "./dialogUpdatePosition.vue?vue&type=script&lang=js"
import style0 from "./dialogUpdatePosition.vue?vue&type=style&index=0&id=31c24624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c24624",
  null
  
)

export default component.exports